import React from "react";
import { useJSONFetcher } from "@outplayed/json-fetcher";
import { WoWContext } from "components/App";
import CopyTalentsButton from "components/Common/CopyTalentsButton";
import { getIcon } from "components/Pages/Builds/WOWBuildsContainer";
import { getParsedSelectedTalents, parseBuildRows } from "lib/wowHelpers";
import { validParams } from "query_parameters/valid_parameters";
import WowTooltip from "components/Tooltips/WowTooltip";

const RosterBlockTalents = ({ classType, specType, talents }) => {
  const specs = validParams.builds.specs[classType];
  const allTrees = {};
  for (let i = 0; i < 4; i++) {
    const { data: specData } = useJSONFetcher(`https://static.bigbrain.gg/wow/tree/v6/${classType}_${specs?.[i]?.value}.json`, {
      ssr: true,
    });
    allTrees[specs?.[i]?.value] = specData;
  }

  const classAndSpecTree = allTrees[specType];

  if (!classAndSpecTree) return null;

  const currentTalents = talents?.split("-") ?? [];
  const { selectedTalents, selectedTalentNodeIds } = getParsedSelectedTalents(currentTalents);
  const lastRowSpecs = parseBuildRows(classAndSpecTree.specNodes, selectedTalents, [10, 9, 8, 7]).slice(0, 6);

  const talentsContext = { allTrees, selectedTalents: currentTalents, specType };

  return (
    <WoWContext.Provider value={talentsContext}>
      <div className="talents-container">
        {lastRowSpecs.map((talent, index) => {
          let spellId, talentName, talentDescription;
          if (talent[1].spells.length > 1) {
            for (let i = 0; i < talent[1].spells.length; i++) {
              // Use nodeEntryId for data from WCL and the definition ID for data from the Blizzard API.
              if (
                selectedTalentNodeIds.includes(talent[1].spells[i].nodeEntryId.toString()) ||
                selectedTalentNodeIds.includes(talent[1].spells[i].definitionId.toString())
              ) {
                spellId = talent[1].spells[i].spellId;
                talentName = talent[1].spells[i].name;
                talentDescription = talent[1].spells[i].description;
              }
            }
          } else {
            spellId = talent[1].spells[0].spellId;
            talentName = talent[1].spells[0].name;
            talentDescription = talent[1].spells[0].description;
          }

          return (
            <WowTooltip type="spell" id={spellId} key={index}>
              {getIcon(1, spellId, "#FF9B00", "36px", index)}
            </WowTooltip>
          );
        })}
        <CopyTalentsButton label="" className="roster-copy-button" />
      </div>
    </WoWContext.Provider>
  );
};

export default RosterBlockTalents;
